var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.589,
    height: 28.236,
    viewBox: "0 0 22.589 28.236",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.471,4.824h2.824V7.647H12.471V4.824M8.235,3.412h2.824V6.235H8.235V3.412m0,4.235h2.824v2.824H8.235V7.647M6.824,10.471v2.824H4V10.471H6.824m0-4.235V9.059H4V6.235H6.824M6.824,2V4.824H4V2H6.824m9.883,28.236a2.824,2.824,0,0,1-2.824-2.824V13.294a2.824,2.824,0,0,1,2.824-2.824V9.059h1.412V4.824h4.235V9.059h1.412v1.412a2.824,2.824,0,0,1,2.824,2.824V27.412a2.824,2.824,0,0,1-2.824,2.824H16.706m0-16.942V27.412h7.059V13.294Z",
    transform: "translate(-4 -2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpray);
export default __webpack_public_path__ + "static/media/spray.2199c527fbd8f70193ef1abf6dfd2da0.svg";
export { ForwardRef as ReactComponent };